import React, { useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import MarketoForm from '../marketo/marketoForm';
import { StaticImage } from "gatsby-plugin-image";
import pptxgen from "pptxgenjs";
import { useRef } from 'react';
import '../../sass/components/flexibleModules/_components.marketingPlanBuilderComponent.scss';

const MarketingPlanBuilderComponent = ({ data }) => {

    const [unlockItem, setUnlockItem] = useState(false);
    // let pres = new pptxgen();

    const [valueZero, setValueZero] = useState("");
    const [nameZero, setNameZero] = useState("");

    const [valueOne, setvalueOne] = useState("");
    const [nameOne, setNameOne] = useState("");

    const [valueTwo, setvalueTwo] = useState("");
    const [nameTwo, setNameTwo] = useState("");

    const [valueThree, setvalueThree] = useState("");
    const [nameThree, setNameThree] = useState("");

    const [valueFour, setvalueFour] = useState("");
    const [nameFour, setNameFour] = useState("");

    const [valueFive, setvalueFive] = useState("");
    const [nameFive, setNameFive] = useState("");

    const [valueSix, setvalueSix] = useState("");
    const [nameSix, setNameSix] = useState("");

    const [valueSeven, setvalueSeven] = useState("");
    const [nameSeven, setNameSeven] = useState("");

    const [valueEight, setvalueEight] = useState("");
    const [nameEight, setNameEight] = useState("");

    const [valueNine, setvalueNine] = useState("");
    const [nameNine, setNameNine] = useState("");

    const [valueTen, setvalueTen] = useState("");
    const [nameTen, setNameTen] = useState("");

    const [valueEleven, setvalueEleven] = useState("");
    const [nameEleven, setNameEleven] = useState("");


    const unlock = (val) => {
        setUnlockItem(val);
        // PPT
        if (val === true) {
            let pres = new pptxgen();
            let textboxOpts = { x: 1, y: 2, color: "363636", fontSize: 18 };
            let nameboxOpts = { x: 1, y: 1, color: "7F56D9", bold: true, fontSize: 36 };

            let slidedefault = pres.addSlide();
            let textboxTextdefault = "Marketing Plan";
            slidedefault.addText(textboxTextdefault, nameboxOpts);

            let slide0 = pres.addSlide();
            let textboxText0 = valueZero ? valueZero : "Field not filled up";;
            let textboxName0 = nameZero ? nameZero : "Field not filled up";;
            slide0.addText(textboxText0, textboxOpts);
            slide0.addText(textboxName0, nameboxOpts);

            let slide1 = pres.addSlide();
            let textboxText1 = valueOne ? valueOne : "Field not filled up";;
            let textboxName1 = nameOne ? nameOne : "Field not filled up";;
            slide1.addText(textboxText1, textboxOpts);
            slide1.addText(textboxName1, nameboxOpts);

            let slide2 = pres.addSlide();
            let textboxText2 = valueTwo ? valueTwo : "Field not filled up";;
            let textboxName2 = nameTwo ? nameTwo : "Field not filled up";;
            slide2.addText(textboxText2, textboxOpts);
            slide2.addText(textboxName2, nameboxOpts);

            let slide3 = pres.addSlide();
            let textboxText3 = valueThree ? valueThree : "Field not filled up";;
            let textboxName3 = nameThree ? nameThree : "Field not filled up";;
            slide3.addText(textboxText3, textboxOpts);
            slide3.addText(textboxName3, nameboxOpts);

            let slide4 = pres.addSlide();
            let textboxText4 = valueFour ? valueFour : "Field not filled up";;
            let textboxName4 = nameFour ? nameFour : "Field not filled up";;
            slide4.addText(textboxText4, textboxOpts);
            slide4.addText(textboxName4, nameboxOpts);

            let slide5 = pres.addSlide();
            let textboxText5 = valueFive ? valueFive : "Field not filled up";;
            let textboxName5 = nameFive ? nameFive : "Field not filled up";;
            slide5.addText(textboxText5, textboxOpts);
            slide5.addText(textboxName5, nameboxOpts);

            let slide6 = pres.addSlide();
            let textboxText6 = valueSix ? valueSix : "Field not filled up";
            let textboxName6 = nameSix ? nameSix : "Field not filled up";
            slide6.addText(textboxText6, textboxOpts);
            slide6.addText(textboxName6, nameboxOpts);

            let slide7 = pres.addSlide();
            let textboxText7 = valueSeven ? valueSeven : "Field not filled up";;
            let textboxName7 = nameSeven ? nameSeven : "Field not filled up";;
            slide7.addText(textboxText7, textboxOpts);
            slide7.addText(textboxName7, nameboxOpts);

            let slide8 = pres.addSlide();
            let textboxText8 = valueEight ? valueEight : "Field not filled up";;
            let textboxName8 = nameEight ? nameEight : "Field not filled up";;
            slide8.addText(textboxText8, textboxOpts);
            slide8.addText(textboxName8, nameboxOpts);

            let slide9 = pres.addSlide();
            let textboxText9 = valueNine ? valueNine : "Field not filled up";;
            let textboxName9 = nameNine ? nameNine : "Field not filled up";;
            slide9.addText(textboxText9, textboxOpts);
            slide9.addText(textboxName9, nameboxOpts);

            let slide10 = pres.addSlide();
            let textboxText10 = valueTen ? valueTen : "Field not filled up";;
            let textboxName10 = nameTen ? nameTen : "Field not filled up";;
            slide10.addText(textboxText10, textboxOpts);
            slide10.addText(textboxName10, nameboxOpts);

            let slide11 = pres.addSlide();
            let textboxText11 = valueEleven ? valueEleven : "Field not filled up";;
            let textboxName11 = nameEleven ? nameEleven : "Field not filled up";;
            slide11.addText(textboxText11, textboxOpts);
            slide11.addText(textboxName11, nameboxOpts);

            pres.writeFile();
        }
        // PPT ends
    }

    const ref = useRef(null);


    const handleMessageChange = (value, name, index) => {
        if (index === 0) {
            setValueZero(value);
            setNameZero(name);
        }
        else if (index === 1) {
            setvalueOne(value);
            setNameOne(name);
        }
        else if (index === 2) {
            setvalueTwo(value);
            setNameTwo(name);
        }
        else if (index === 3) {
            setvalueThree(value);
            setNameThree(name);
        }
        else if (index === 4) {
            setvalueFour(value);
            setNameFour(name);
        }
        else if (index === 5) {
            setvalueFive(value);
            setNameFive(name);
        }
        else if (index === 6) {
            setvalueSix(value);
            setNameSix(name);
        }
        else if (index === 7) {
            setvalueSeven(value);
            setNameSeven(name);
        }
        else if (index === 8) {
            setvalueEight(value);
            setNameEight(name);
        }
        else if (index === 9) {
            setvalueNine(value);
            setNameNine(name);
        }
        else if (index === 10) {
            setvalueTen(value);
            setNameTen(name);
        }
        else if (index === 11) {
            setvalueEleven(value);
            setNameEleven(name);
        }
        else {
            console.log("not valid");
        }
        // 👇️ access textarea value
        //   setList([...list, list.filter((item) => item.id === event.target.name)]);
        //   alert("ref: "+event.target.value);
        //   alert("event: "+ event.target.name)
    };

    return (
        <div className="cp-marketoPlanBuilderFlexiComponent">
            <div className="cp-marketoPlanBuilderFlexiComponent__inner">
                {data.marketingPlanBuilderComponentHeader &&
                    <h2>{data.marketingPlanBuilderComponentHeader}</h2>
                }
                {data.marketingPlanBuilderComponentTeaser &&
                    <div dangerouslySetInnerHTML={{ __html: data.marketingPlanBuilderComponentTeaser }} />
                }
                {data.marketingPlanBuilderComponentSections &&
                    <div className="cp-marketoPlanBuilderFlexiComponent__wrap">
                        <div className="cp-marketoPlanBuilderFlexiComponent__wrap-top l--flex">
                            <span>Score My Marketing Plan</span>
                            <button className="l-button js-presentation" onClick={() => unlock(true)}>Download Plan Presentation</button>
                        </div>
                        <div className="cp-marketoPlanBuilderFlexiComponent__wrap-bottom">
                            {data.marketingPlanBuilderComponentSections.map((builder, index) => (
                                <div className="l-builderSection" key={index}>
                                    <div className="l-builderSection__top l--flex">
                                        {builder.icon &&
                                            <GatsbyImage image={getImage(builder.icon.gatsbyImage)} alt={builder.icon.altText} />
                                        }
                                        {builder.header &&
                                            <h3>{builder.header}</h3>
                                        }
                                    </div>
                                    <div className="l-builderSection__bottom l--flex">
                                        <div>
                                            <textarea onChange={e => handleMessageChange(e.target.value, e.target.name, index)} ref={ref} name={builder.header} />
                                        </div>
                                        {builder.content &&
                                            <div dangerouslySetInnerHTML={{ __html: builder.content }} />
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="cp-marketoPlanBuilderFlexiComponent__wrap-top l--flex l--topBottom">
                            <button className="l-button js-presentation" onClick={() => unlock(true)}>Download Plan Presentation</button>
                        </div>
                    </div>
                }
            </div>
            <div className={`l--formpopup ${unlockItem ? "l-showForm" : "l-hideForm"}`}>
                <div className="l--formpopup__inner">
                    <MarketoForm ctaOverride="Download Now" formID="3597" formSubmitMessage="Thank you for downloading Planful's Marketing Plan Builder editable slides!" />
                    <button className="cp-formpopup__close" onClick={() => unlock(false)}>
                        <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                    </button>
                </div>
                <button className="l-formpopupClose" onClick={() => unlock(false)}></button>
            </div>
        </div>
    );
}

export default MarketingPlanBuilderComponent;